import { formatDate } from "../../../../_src_shared/utils/functions/formatDate";
import { formatDollar } from "../../../../utils/numbers/formatDollar";
import PdfArrayObjectItem from "../../pdfBuilder/components/PdfArrayObjectItem";
import PdfPageBrandedSubmission from "../../pdfBuilder/pages/PdfPageBrandedSubmission";
import PdfBuilderDataItemRow from "../../pdfBuilder/components/data/PdfBuilderDataItemRow";

const PdfPageSubjectProperties = ({ formData }) => {
  return (
    <PdfPageBrandedSubmission
      pageNumber={"4 of 6"}
      pageTitle={"Subject Properties"}
      submittedBy={`${formData.firstName} ${formData.lastName}`}
      submittedDate={formData?.submission_date}
    >
      {formData.subjectProperties &&
        formData.subjectProperties.map((property, index) => (
          <PropertySection key={index} property={property} index={index} />
        ))}
    </PdfPageBrandedSubmission>
  );
};

const PropertySection = ({ property, index }) => {
  return (
    <PdfArrayObjectItem title={`Property #${index + 1}`}>
      <PdfBuilderDataItemRow
        label="Address:"
        value={property.address?.fullAddress || "Not provided"}
      />

      <PdfBuilderDataItemRow
        label="Property Type:"
        value={property.propertyType || "Not specified"}
      />

      <PdfBuilderDataItemRow
        label="As-Is Value:"
        value={formatDollar(property.asIsValue)}
      />

      <PdfBuilderDataItemRow label="ARV:" value={formatDollar(property.arv)} />

      <PdfBuilderDataItemRow
        label="Purchase Price:"
        value={formatDollar(property.purchasePrice)}
      />

      <PdfBuilderDataItemRow
        label="Purchase Date:"
        value={formatDate(property.purchaseDate)}
      />
      <PdfBuilderDataItemRow
        label="Square Footage:"
        value={`${property.residentialSqFootage || "Not provided"} sq ft`}
      />

      <PdfBuilderDataItemRow
        label="Property Condition:"
        value={property.propertyConditionAtOrigination || "Not specified"}
      />

      <PdfBuilderDataItemRow
        label="Construction Budget:"
        value={formatDollar(property.constructionBudget)}
      />

      <PdfBuilderDataItemRow
        label="Annual Taxes:"
        value={formatDollar(property.annualTaxes)}
      />

      <PdfBuilderDataItemRow
        label="Annual Insurance:"
        value={formatDollar(property.annualInsurance)}
      />
    </PdfArrayObjectItem>
  );
};

export default PdfPageSubjectProperties;
